"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _recharts = require("recharts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FullPieChartComponent = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 800 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 400 : _ref$height,
      _ref$startAngle = _ref.startAngle,
      startAngle = _ref$startAngle === void 0 ? 90 : _ref$startAngle,
      _ref$endAngle = _ref.endAngle,
      endAngle = _ref$endAngle === void 0 ? 450 : _ref$endAngle,
      data = _ref.data,
      COLORS = _ref.COLORS,
      _ref$coordinateX = _ref.coordinateX,
      coordinateX = _ref$coordinateX === void 0 ? 300 : _ref$coordinateX,
      _ref$coordinateY = _ref.coordinateY,
      coordinateY = _ref$coordinateY === void 0 ? 150 : _ref$coordinateY,
      _ref$innerRadius = _ref.innerRadius,
      innerRadius = _ref$innerRadius === void 0 ? 72 : _ref$innerRadius,
      _ref$outerRadius = _ref.outerRadius,
      outerRadius = _ref$outerRadius === void 0 ? 80 : _ref$outerRadius,
      fill = _ref.fill,
      _ref$paddingAngle = _ref.paddingAngle,
      paddingAngle = _ref$paddingAngle === void 0 ? 0 : _ref$paddingAngle,
      dataKey = _ref.dataKey,
      position = _ref.position,
      verticalAlign = _ref.verticalAlign,
      layout = _ref.layout,
      align = _ref.align,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 10 : _ref$iconSize,
      iconType = _ref.iconType,
      wrapperStyle = _ref.wrapperStyle,
      renderLegends = _ref.renderLegends,
      percentage = _ref.percentage,
      labelFill = _ref.labelFill,
      hideLegend = _ref.hideLegend,
      pieLabelClassName = _ref.pieLabelClassName;
  return /*#__PURE__*/_react["default"].createElement(_recharts.ResponsiveContainer, {
    width: "100%",
    height: "80%"
  }, /*#__PURE__*/_react["default"].createElement(_recharts.PieChart, null, /*#__PURE__*/_react["default"].createElement(_recharts.Pie, {
    data: data,
    startAngle: startAngle,
    endAngle: endAngle,
    cx: coordinateX,
    cy: coordinateY,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    fill: fill,
    paddingAngle: paddingAngle,
    dataKey: dataKey
  }, data === null || data === void 0 ? void 0 : data.map(function (entry, index) {
    return /*#__PURE__*/_react["default"].createElement(_recharts.Cell, {
      key: "cell-".concat(index),
      fill: COLORS === null || COLORS === void 0 ? void 0 : COLORS[index % (COLORS === null || COLORS === void 0 ? void 0 : COLORS.length)]
    });
  }), percentage && /*#__PURE__*/_react["default"].createElement(_recharts.Label, {
    fill: labelFill,
    className: pieLabelClassName,
    position: position,
    value: percentage
  })), !hideLegend && /*#__PURE__*/_react["default"].createElement(_recharts.Legend, {
    iconType: iconType,
    verticalAlign: verticalAlign,
    layout: layout,
    align: align,
    iconSize: iconSize,
    wrapperStyle: wrapperStyle,
    content: renderLegends
  })));
});

var _default = FullPieChartComponent;
exports["default"] = _default;